import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EsnEvaluationService extends CrudService<
  ApiResponse<any>,
  number
> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* get list sentevaluation */

  getListsentevaluation(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/EvaluationSend/getEvaluationsSendByESN?id=${data.id}&
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }
  // filter list sent evaluation
  filterListsentevaluation(data: any) {
    return this._http
      .post<ApiResponse<any>>(
        `${this._base}/api/EvaluationSend/filterEvaluationsSendByESN`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  // search sentevaluation//////
  searchsentevaluation(id: any, data: any): Observable<ApiResponse<any>> {

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/EvaluationSend/searchEvaluationsSendByESN?id=${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  searchListPv(id: any, data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/Pv/searchInListPvsByESN?id=${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }


  // get detail evaluation//////
  getevaluationbyid(id: any): Observable<ApiResponse<any>> {
    return this._http
    .get<ApiResponse<any>>(
      this._base +
        `/api/EvaluationSend/getEvaluationsByCandidateDeatils?id=${id}`
    )
    .pipe(
      map((res: any) => {
        if (res) {
          return res;
        }
      })
    );
  }

  // get detail evaluation receive//////
  getevaluationreceivebyid(id: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/EvaluationSend/getEvaluationsByCandidateDeatils?id=${id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  /* get list evaluationreceived */

  getListreceivedevaluation(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/EvaluationSend/getEvaluationsRecievedByESN?id=${data.id}&
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }

  updateEvaluationResponses(id: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/ResponseEvaluation/update/${id}`,
      data
    );
  }

  // search receivedevaluation//////
  searchreceivedevaluation(id: any, data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/EvaluationSend/searchEvaluationsRecievedByESN?id=${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  // filter list received evaluation
  filterListreceivedevaluation(data: any) {
    return this._http
      .post<ApiResponse<any>>(
        `${this._base}/api/EvaluationSend/filterEvaluationsRecievedByESN`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  /* get list sentevaluation */

  getListevaluateurs(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/EvaluationSend/getlistOfevaluatorsByEvaluation?id=${data.id}&
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }

  // search evaluateur/
  searchevaluateur(id: any, search: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/EvaluationSend/searchinlistOfevaluatorsByEvaluation?id=${id}&search=${search}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  ajoutercompterendu(data: any) {
    return this._http.post<ApiResponse<any>>(this._base + `/api/Pv/add`, data);
  }
  updatecompterendu(idCra:any,data: any) {
    return this._http.post<ApiResponse<any>>(this._base + `/api/Pv/update/${idCra}`, data);
  }

  addSignature(id: any, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/pvEsn/signPvReport/${id}`,
      data
    );
  }
  telechagementPV(idPv: any) {
    let url = `${this._base}/api/pvEsn/generatePv/${idPv}`
    return this._http.get(url, {responseType: 'arraybuffer',});
  }
  /*listpv*/
  getAllListPvs(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/Pv/getAllPvsByESN?id=${data.id}&
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }
  getAllDetailsOfPv(id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/pvEsn/getPvDetailsById/${id}`
    );
  }

  sendpv(id: any,idesn:any, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Pv/sendPV?${id}&esn_id=${idesn}`,
      data
    );
  }
  deletepv(id: any): Observable<any> {
    const url = `${this._base}/api/Pv/delete?id=${id}`; // Assurez-vous d'utiliser la route correcte de mise à jour
    return this._http.delete(url);
  }
  addEvaluationResponses(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/ResponseEvaluation/addResponse`,
      data
    );
  }

  /* get list activities cra */
  getListCra(data?: {
    per_page?: number;
    page?: number;
  }) {
    let page=1
   if(data?.page){
    page=data?.page+1
   }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/SpecificTypeOfCra/getAll?per_page=${data?.per_page}&page=${page}`
    );
  }

  addTypeActivity(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/SpecificTypeOfCra/add`,
      data
    );
  }
  /* update activity cra */
  updateActivityCra(idCra: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/SpecificTypeOfCra/update/${idCra}`,
      data
    );
  }
  /* delete activity cra */
  deleteActivityCra(idCra: number) {
    return this._http.delete<ApiResponse<any>>(
      this._base + `/api/SpecificTypeOfCra/delete/${idCra}`
    );
  }
  /* search activity cra */
  searchCra(data: any) {
    if(data.page){
      data.page=data.page+1
    } else{
      data.page=1
    }
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/SpecificTypeOfCra/search`,
      data
    );
  }

  getSignatureImage(idPv: any, type: string) {
    return this._http.get(
      `${this._base}/api/pvEsn/pv/${idPv}/signature/${type}/display`,
      { responseType: 'blob' as 'blob' }
    );
  }
}
